var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 385,
    viewBox: "0 0 414 385",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "26.568%",
    x2: "50%",
    y2: "95.472%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371D6E",
    stopOpacity: 0.105,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.674%",
    y1: "72.472%",
    x2: "65.51%",
    y2: "34.395%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683EA7",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371D6E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "26.568%",
    x2: "50%",
    y2: "95.472%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371D6E",
    stopOpacity: 0.105,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.256%",
    y1: "50%",
    x2: "80.75%",
    y2: "54.54%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683EA7",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371D6E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "26.568%",
    x2: "50%",
    y2: "95.472%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371D6E",
    stopOpacity: 0.105,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thoughtful-Technology---Integrations",
    transform: "translate(-877 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "integration",
    transform: "translate(854 160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    fill: "url(#linearGradient-1)",
    filter: "url(#filter-2)",
    d: "M172.893 141.147v117.956l142.098 1.728 1.37-119.684-70.08 43.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297 156.248 33.971 20.279a2 2 0 0 0 3.025-1.748l-.846-55.134a2 2 0 0 1 3.023-1.749l39.319 23.414",
    id: "Path-Copy-3",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 672.492 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    fill: "url(#linearGradient-4)",
    filter: "url(#filter-5)",
    d: "M271 307.627v110.984h105.99V307.627l-53.49 30.548z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2-Copy-3",
    fill: "#F3B100",
    d: "M173 71v70.253l73.837 41.77 69.737-40.44V71.032z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-34",
    fill: "#D7C5FD",
    transform: "rotate(45 244.795 71)",
    d: "m215.289 40.216 80.284-19.949-21.064 79.169-80.5 22.394z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4-Copy-17",
    fill: "#371D6E",
    d: "M173 71v71.144l73.837 40.88-.407-71.168z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFF",
    cx: 256,
    cy: 168.127,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 167.992 39.31 26.474a2 2 0 0 1-.137 3.402l-29.196 16.42a2 2 0 0 0-.06 3.452L298 237.28",
    id: "Path",
    stroke: "#371D6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2-Copy-3",
    fillOpacity: 0.665,
    fill: "#F3B100",
    d: "M269.503 255.439v51.886l54.507 30.85 51.482-29.868v-52.845z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-34",
    fill: "#E5D9FF",
    transform: "rotate(45 322.476 255.462)",
    d: "m300.686 232.69 59.278-14.716-15.54 58.454-59.437 16.522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.933 345.496-90.378-20.058",
    id: "Path-6-Copy-4",
    stroke: "#D7C5FD",
    strokeDasharray: 2,
    transform: "rotate(-103 270.466 335.323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.061 272.762 37.87 258.635",
    id: "Path-6-Copy-5",
    stroke: "#C5ACFA",
    strokeDasharray: 2,
    transform: "rotate(-103 68.281 265.52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFF",
    cx: 332,
    cy: 322.127,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4-Copy-17",
    fill: "#C5ACFA",
    d: "M269.503 255.439v52.544l54.507 30.192-.3-52.561z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333 296.627 39.165 24.854a2 2 0 0 1-.098 3.435l-8.983 5.011a2 2 0 0 0-.02 3.482l29.956 17.193a4 4 0 0 0 3.962.011l49.86-28.22",
    id: "Path-Copy",
    stroke: "url(#linearGradient-6)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 779.841 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2-Copy-3",
    fillOpacity: 0.665,
    fill: "#F3B100",
    d: "M67.986 205.439v51.886l54.507 30.85 51.482-29.868v-52.845z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-34",
    fill: "#E5D9FF",
    transform: "rotate(45 120.959 205.462)",
    d: "m99.17 182.69 59.277-14.716-15.54 58.454L83.47 242.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    fill: "url(#linearGradient-7)",
    filter: "url(#filter-8)",
    d: "M67.986 257.627v107.984h105.989V257.627l-51.482 30.548z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4-Copy-17",
    fill: "#C5ACFA",
    d: "M67.986 205.439v52.544l54.507 30.192-.3-52.561z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "#C5ACFA",
    cx: 361.5,
    cy: 215.127,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#F3B100",
    cx: 144.5,
    cy: 138.127,
    r: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFF",
    cx: 114,
    cy: 275.127,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    fill: "#FFF",
    cx: 129,
    cy: 275.127,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFBADD",
    cx: 217.952,
    cy: 323.127,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 156.248V253.8a3 3 0 0 0 1.41 2.543l10.396 6.503a3 3 0 0 1-.02 5.1l-52.86 32.483a3 3 0 0 1-3.089.032L129 275.33",
    id: "Path-8",
    stroke: "#371D6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 249.627 39.165 24.854a2 2 0 0 1-.098 3.435l-8.983 5.011a2 2 0 0 0-.02 3.482l29.956 17.193a4 4 0 0 0 3.962.011l49.86-28.22",
    id: "Path-Copy-2",
    stroke: "url(#linearGradient-6)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.092 368.816-73.71-17.018",
    id: "Path-6-Copy-7",
    stroke: "#FFBADD",
    strokeDasharray: 2,
    transform: "rotate(-103 218.093 360.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.282 83.83-59.804 62.82",
    id: "Path-6-Copy-3",
    stroke: "#F3B100",
    strokeDasharray: 2,
    transform: "rotate(-103 106.04 115.544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.282 205.83-59.804 62.82",
    id: "Path-6-Copy-6",
    stroke: "#C5ACFA",
    strokeDasharray: 2,
    transform: "rotate(-103 400.04 237.544)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockArt);
export default __webpack_public_path__ + "static/media/block-art.348c05604db52cc85e9ead81255a8894.svg";
export { ForwardRef as ReactComponent };